import { FC } from "react";
import { FieldValues, useController, UseControllerProps } from "react-hook-form";

export function withController<T>(Component: FC<T>) {
  return function ControlledComponent<U extends FieldValues>({ name, control, defaultValue, disabled, rules, shouldUnregister, ...props }: T & UseControllerProps<U>) {
    const {
      field: { disabled: disabledState, name: nameState, ...controllerRest },
      fieldState: { error: fieldError }
    } = useController({ name, control, defaultValue, disabled, rules, shouldUnregister });

    return <Component disabled={disabledState} name={nameState} error={fieldError?.message} {...controllerRest} {...(props as T)} />;
  };
}
